import React from "react";
import { characters } from "../data/characters";

const Marquee = () => {
  const items = [
    ...characters.map((c) => `${c.name} • ${c.archetype}`),
    "AI Character Chat",
    "Roleplay 24/7",
    "Instant Replies",
    "Always Online",
  ];
  const repeated = [...items, ...items];
  return (
    <div
      data-testid="character-marquee"
      className="w-full overflow-hidden border-y-2 border-black bg-black text-white py-4"
    >
      <div className="marquee-track">
        {repeated.map((t, i) => (
          <span
            key={i}
            className="font-display font-black uppercase tracking-tight text-2xl sm:text-4xl px-8 whitespace-nowrap"
          >
            {t}
            <span aria-hidden className="text-[#00E5FF] mx-6">
              ✦
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
